import * as postProviders from "./kw-post-providers";
const formUtmPrepare = postProviders.formUtmPrepare;

// See https://github.com/daneden/animate.css/issues/644
const animationEnd = ((el) => {
  var animations = {
    animation: "animationend",
    OAnimation: "oAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    WebkitAnimation: "webkitAnimationEnd",
  };
  for (var t in animations) {
    if (el.style[t] !== undefined) {
      return animations[t];
    }
  }
})(document.createElement("div"));

const formsInit = (
  wrapSelector = 'div[data-name="kw-callback-form"]',
  mainSelector,
  successCb,
  amoCrmHook = "",
) => {
  const forms = document.querySelectorAll(wrapSelector);
  const errMsg = { _member_email: "Введите действующий email" };
  const errClass = "kw-error";
  const saveInputValue = {};

  let debounceMutex = false;
  window.onresize = function (e) {
    if (debounceMutex) return;
    debounceMutex = true;
    forms.forEach((item, index) => {
      const kwForm = item.querySelector("div.kw-form");
      if (!kwForm) return;

      let main = null;
      if (mainSelector) {
        main = item.querySelector(mainSelector);
      }
      if (!main) {
        main = item;
      }
      setTimeout(() => {
        main.style.setProperty("max-height", `${kwForm.offsetHeight}px`);
        main.style.setProperty("height", `${kwForm.offsetHeight}px`);
        if (forms.length == index + 1) {
          debounceMutex = false;
        }
      }, 100);
    });
  };

  forms.forEach((item) => {
    const form = item.querySelector("form");
    const kwForm = item.querySelector("div.kw-form");
    const kwFormSuccess = item.querySelector("div.kw-form.hidden");
    form.reset();

    const animationIn = "fadeIn";
    const animationOut = "fadeOutUp";

    let main = null;
    if (mainSelector) {
      main = item.querySelector(mainSelector);
    }
    if (!main) {
      main = item;
    }

    if (kwForm) {
      setTimeout(() => {
        if (kwForm.offsetHeight > 0) {
          main.style.setProperty("max-height", `${kwForm.offsetHeight}px`);
          main.style.setProperty("height", `${kwForm.offsetHeight}px`);
        }
      }, 500);
    }

    const inputs = [
      ...Array.from(item.querySelectorAll("input:not([type=submit])")),
      ...Array.from(item.querySelectorAll("textarea")),
    ];

    const axiosProcess = (state = true) => {
      inputs.forEach((input) => {
        if (state) {
          input.disabled = true;
        } else {
          input.disabled = false;
        }
      });
      const btnSubmit = item.querySelector("[type=submit]");
      if (state) {
        btnSubmit.disabled = true;
      } else {
        btnSubmit.disabled = false;
        setTimeout(() => {
          main?.style?.setProperty("max-height", `${kwForm.offsetHeight}px`);
          main?.style?.setProperty("height", `${kwForm.offsetHeight}px`);
        }, 100);
      }
    };
    const sendErrorStatus = (error) => {
      const msg = error.error || error;
      const errorString = msg && msg !== true ? msg : errMsg[input.name];
      if (typeof errorString !== "string") {
        return;
      }

      inputs.forEach((input) => {
        input.classList.add(errClass);
        saveInputValue[input.name] = input.value;
        input.blur();

        const errorDiv = input.nextElementSibling;
        if (errorDiv?.classList.contains("kw-form--error")) {
          errorDiv.innerText = errorString;
        } else if (input.type !== "hidden") {
          input.value = errorString;
        }

        input.addEventListener(
          "focus",
          () => {
            input.classList.remove(errClass);
            input.value = saveInputValue[input.name];
          },
          { once: true },
        );
      });
    };
    const sendSuccessStatus = () => {
      if (!main || !form || !kwForm || !kwFormSuccess) return;
      form.reset();
      function showFormHideSuccess() {
        kwFormSuccess.classList.add("hidden");
        kwForm.classList.remove("hidden");
        main.style.setProperty("max-height", `${kwForm.offsetHeight}px`);
        main.style.setProperty("height", `${kwForm.offsetHeight}px`);
        kwForm.classList.add("animated", animationIn);
      }
      function hideFormShowSuccess() {
        kwForm.classList.add("hidden");
        kwFormSuccess.classList.remove("hidden");
        main.style.setProperty("max-height", `${kwFormSuccess.offsetHeight}px`);
        main.style.setProperty("height", `${kwFormSuccess.offsetHeight}px`);
        kwFormSuccess.classList.add("animated", animationIn);
      }
      function okHandler(e) {
        kwFormSuccess.classList.remove("animated", animationIn);
        kwFormSuccess.classList.add("animated", animationOut);
        kwForm.classList.remove("animated", animationOut);
        if (e.target.dataset?.action === "close") {
          showFormHideSuccess();
        } else {
          kwFormSuccess.addEventListener(animationEnd, showFormHideSuccess, {
            once: true,
          });
        }
      }
      const btnOk = item.querySelector("button[data-name=kw-form-ok]");
      if (btnOk) {
        btnOk.addEventListener("click", okHandler);
      }

      kwFormSuccess.classList.remove("animated", animationOut);
      kwForm.classList.remove("animated", animationIn);
      kwForm.classList.add("animated", animationOut);
      kwForm.addEventListener(animationEnd, hideFormShowSuccess, {
        once: true,
      });
    };

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const rawFormDataObj = formUtmPrepare(form);

      const intputs = e.target.querySelectorAll("input");
      intputs.forEach((input) => {
        if (input.type == "tel") {
          input.name = "phone";
        } else if (input.placeholder.toLowerCase().includes("имя")) {
          input.name = "name";
        } else if (input.type == "email") {
          input.name = "email";
        } else if (
          !Object.hasOwn(postProviders.feildsDic, input.name) &&
          input.previousElementSibling?.tagName == "SPAN" &&
          input.previousElementSibling.innerText
        ) {
          input.name = input.previousElementSibling.innerText;
        }
      });

      const formDataObj = formUtmPrepare(form);

      axiosProcess(true);
      const promiseFormAction = (async () => {
        if (form.dataset.action === "none") {
          return Promise.resolve();
        } else if (form.dataset.action === "email") {
          const title =
            form.dataset.title || formDataObj["form_name"] || formDataObj["formname"] || "Заявка с сайта";
          const dic = {};
          inputs.forEach((input) => {
            dic[input.name] =
              input.dataset.name || input.placeholder || input.name;
          });

          return postProviders.sendEmail(formDataObj, dic, {
            title,
            subject: form.dataset.subject || title,
            key: form.id,
          });
        } else {
          return postProviders.formSubmitHandler(form.action, rawFormDataObj);
        }
      })()
        .then((res) => {
          sendSuccessStatus();
          if (typeof successCb === "function") {
            successCb();
          }
          return Promise.resolve();
        })
        .catch((error) => {
          sendErrorStatus(error);
          console.log(error);
        });

      const promiseAmoCrm = postProviders.amoCrmPost(
        amoCrmHook || form.dataset.amocrmhook,
        formDataObj,
        { referer: document.referrer },
      );

      Promise.allSettled([promiseAmoCrm, promiseFormAction]).then((results) => {
        // if (debugInfoLevel) console.log("all fetch is done: ", results);
        axiosProcess(false);
      });
    });
  });
};

export { formsInit };
